import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { IModule, ModuleId } from '@soleran/module';

@Component({
  selector: 'app-module-picker',
  templateUrl: './module-picker.component.html',
  styles: [
    `
      .module-picker-input {
        width: 100%;
        cursor: pointer;
      }
    `,
  ],
})
export class ModulePickerComponent implements OnInit {
  @Input() hint!: string;
  @Input() label: string = 'Modules';
  @Input() modules: IModule[] = [];
  @Output() selectedModuleIdsChange = new EventEmitter<ModuleId[]>();
  selectedModuleIds: number[] = [];
  selectedModules: IModule[] = [];
  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modules'] && this.modules?.length) {
      const ids = this.modules.map((m) => m.id);
      this._setSelectedModules(ids);
    }
  }
  onPicked(selectedModules: IModule[] | any) {
    const ids = selectedModules.map((m: any) => m.id);
    this._setSelectedModules(ids);
  }
  onRemove(module: IModule) {
    this._removeSelectedModule(module);
  }
  private _removeSelectedModule(module: IModule) {
    const ids = this.selectedModules
      .map((m) => m.id)
      .filter((id) => module.id !== id);
    this._setSelectedModules(ids);
  }
  private _setSelectedModules(moduleIds: number[]) {
    this.selectedModuleIds = (moduleIds || []).slice();
    this.selectedModules = (this.modules || []).filter((m) =>
      this.selectedModuleIds.some((id) => id === m.id)
    );
    this.selectedModuleIdsChange.emit(this.selectedModuleIds);
  }
}
